import type { StageLog } from '@/types'

/** Everyone credited on a stage line: the operator who logged it, then their teammates. */
export function workedBy(log: Pick<StageLog, 'staff' | 'helpers'>): string {
  return [log.staff, ...(log.helpers ?? [])].filter(Boolean).join(', ')
}

/** Short form for tight spaces such as the printed job sheet: "Ali +2". */
export function workedByShort(log: Pick<StageLog, 'staff' | 'helpers'>): string {
  const extra = log.helpers?.length ?? 0
  return extra > 0 ? `${log.staff} +${extra}` : log.staff
}
